import { render, staticRenderFns } from "./showWorkflow.vue?vue&type=template&id=2f6c4d7a&"
import script from "./showWorkflow.vue?vue&type=script&lang=js&"
export * from "./showWorkflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports